const arraysIntersect = (array1: any[], array2: any[]) => {
  return array1.some((item) => array2.includes(item));
}

export default arraysIntersect;const arraysIntersect = (array1: any[], array2: any[]) => {
  return array1.some((item) => array2.includes(item));
}

export default arraysIntersect;